import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { AccuracyDetailItem } from '../../../../../model/caf.interface'
import {
  useCafAnalysisComponentDetailListV5,
  useCafAnalysisComponentDetailV5,
} from '../../../../../modules/apis/webview/caf'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { mapAccuracyEnum, mapAccuracyEnumEN } from '../../../../../modules/hooks/webview/caf/common/useMapAccuracyEnum'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { ICON_CHEVRON_RIGHT_GRAY } from '../../../../../modules/svg/svg'
import urls from '../../../../../modules/urls'
import AccuracyIntroSection from '../../analysis/accuracy/AccuracyIntroSection'
import ThickDivider from '../../common/ThickDivider'
import useMetricDetailSidePopup from '../popup/useMetricDetailSidePopup'

interface Props {
  componentId: number
}
const INITIAL_METRIC_STATE = {
  metricId: -1,
  metricTag: -1,
  errorTag: -1,
  errorType: '',
}
const CAFOverviewAccuracy = ({ componentId }: Props) => {
  const router = useAppRouter()
  const { t, locale } = useTranslation()
  const { lessonId, tab } = router.query
  const { isLoading } = useCafAnalysisComponentDetailV5(+componentId)
  const { data } = useCafAnalysisComponentDetailListV5(componentId)
  const [selectedMetric, setSelectedMetric] = useState(INITIAL_METRIC_STATE)
  useMetricDetailSidePopup()
  const handleClickErrorItem = (metricId: number, metricTag: number, errorType: string, errorTag: number) => {
    selectedMetric.errorTag === errorTag
      ? setSelectedMetric(INITIAL_METRIC_STATE)
      : setSelectedMetric({
          metricId,
          metricTag,
          errorTag,
          errorType,
        })
  }

  useEffect(() => {
    const title = mapAccuracyEnum(selectedMetric.errorTag, t)
    router.push(
      urls.student.newPortal.lessons.reviewDetail.asCafAccuracyMetricDetail(
        lessonId,
        selectedMetric.metricId,
        selectedMetric.errorTag,
        title
      )
    )
  }, [selectedMetric, lessonId])

  return (
    <div className="w-screen px-[16px] sm:w-[424px] sm:px-0">
      <div className="keep-all min-h-screen break-words bg-white pt-[16px] pb-[40px] text-gray-700">
        <div className="mb-[16px] flex flex-row items-center justify-start text-[20px] font-bold text-black">
          {t(n_caf.highlight_list.accuracy1)}
          <div className="ml-[8px] rounded-[4px] bg-red-50 px-[6px] py-[2px] text-[10px] font-bold text-red-400">
            Beta
          </div>
        </div>
        <AccuracyIntroSection componentId={componentId} />
        <ThickDivider />
        <div className="mb-[16px] mt-[20px] text-[20px] font-bold text-black">
          {t(n_caf.accuracy.grammarerror_type)}
        </div>
        {data?.metrics[0]?.details?.map((metricItem: AccuracyDetailItem) => (
          <ArrowLinkBoxBG
            key={metricItem.error_type + '_metric'}
            title={mapAccuracyEnum(metricItem.error_tag, t)}
            subText={locale === 'ko' && mapAccuracyEnumEN(metricItem.error_tag, t)}
            rightText={metricItem.count}
            active={!!metricItem.count}
            isSelected={selectedMetric.errorTag === metricItem.error_tag}
            onClick={
              metricItem.count > 0
                ? () =>
                    handleClickErrorItem(
                      data.metrics[0].metric_id,
                      data.metrics[0].metric_tag,
                      metricItem.error_type,
                      metricItem.error_tag
                    )
                : null
            }
          />
        ))}
      </div>
    </div>
  )
}
interface ArrowLinkBoxBGType {
  title: string | React.ReactFragment | React.ReactElement
  subText?: string | React.ReactFragment | React.ReactElement
  rightText?: string | number
  active?: boolean
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  isSelected: boolean
}

const ArrowLinkBoxBG = ({ title, rightText, active, subText, onClick, isSelected }: ArrowLinkBoxBGType) => {
  return (
    <div
      className={classNames(
        `mb-[8px] flex min-h-[62px] cursor-pointer items-center rounded-[6px] px-[16px] py-[12px] shadow-sm sm:min-h-[72px]`,
        isSelected ? 'bg-purple-50' : active ? 'bg-white' : 'bg-gray-100',
        isSelected ? 'border-[1.5px] border-purple-500' : 'border-[1px] border-gray-100'
      )}
      onClick={onClick}
    >
      <div className="flex flex-1 items-center justify-between">
        <div>
          <h3
            className={classNames(
              'text-h5 sm:text-[16px]',
              isSelected ? 'text-purple-500' : active ? 'text-black' : 'text-gray-500'
            )}
          >
            {title}
          </h3>
          {subText && <p className="mt-[2px] text-[12px] capitalize text-gray-500  sm:text-[14px]">{subText}</p>}
        </div>
        <div className="flex items-center">
          {!!String(rightText) && <span className="text-h5 mr-[16px] text-gray-500 sm:text-[16px]">{rightText}</span>}
          <img src={ICON_CHEVRON_RIGHT_GRAY} alt="chevron" />
        </div>
      </div>
    </div>
  )
}

export default CAFOverviewAccuracy
